import PropTypes from "prop-types";
import DeliveryNoteTemplatePreview from "./DeliveryNoteTemplatePreview";

const DeliveryNoteExportSheet = ({
  snapshot,
  resolveImage,
  note,
  sheetRef,
}) => (
  <div
    className="delivery-note-preview-export"
    id="delivery-note-preview-export-root"
    ref={sheetRef}
  >
    <DeliveryNoteTemplatePreview
      snapshot={snapshot}
      resolveImage={resolveImage}
      showTitle={false}
      showPlaceholders={false}
      scaleToContainer={false}
      note={note}
    />
  </div>
);

DeliveryNoteExportSheet.propTypes = {
  snapshot: PropTypes.object.isRequired,
  resolveImage: PropTypes.func.isRequired,
  note: PropTypes.object.isRequired,
  sheetRef: PropTypes.object.isRequired,
};

export default DeliveryNoteExportSheet;
